/** @jsx jsx */
import { Flex as BaseFlex, jsx } from 'theme-ui';

export default function Flex({
  direction,
  wrap,
  gap,
  justify,
  align,
  ...rest
}) {
  return (
    <BaseFlex
      sx={{
        flexDirection: direction,
        flexWrap: wrap,
        justifyContent: justify,
        alignItems: align,
        // A "polyfill" for the missing flex-gap property.
        '> :not(:last-child)': gap
          ? direction?.includes('reverse')
            ? { marginLeft: gap }
            : { marginRight: gap }
          : undefined,
      }}
      {...rest}
    />
  );
}
